"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _classcat = _interopRequireDefault(require("classcat"));

var _InputError = _interopRequireDefault(require("./InputError"));

var _Backdrop = _interopRequireDefault(require("./Backdrop"));

var _SVGIcon = _interopRequireDefault(require("./SVGIcon"));

var _LabelText = _interopRequireDefault(require("./LabelText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const SelectedItem = _styledComponents.default.div.withConfig({
  displayName: "ComboBox__SelectedItem",
  componentId: "l8utvg-0"
})(["background:#fff;border:1px solid #a9a9a9;cursor:pointer;display:flex;height:48px;line-height:48px;margin-top:8px;position:relative;width:100%;", " ", " ", "{height:48px;width:48px;padding:12px;}"], p => p.err && (0, _styledComponents.css)(["border-color:", ";"], p.theme.colors.err), p => p.active && (0, _styledComponents.css)(["border-color:#fff;border-bottom-color:#a9a9a9;z-index:2;"]), _SVGIcon.default);

const SelectedItemText = _styledComponents.default.div.withConfig({
  displayName: "ComboBox__SelectedItemText",
  componentId: "l8utvg-1"
})(["flex:1;padding:0 16px;"]);

const Items = _styledComponents.default.div.withConfig({
  displayName: "ComboBox__Items",
  componentId: "l8utvg-2"
})(["ul{position:absolute;z-index:2;top:48px;right:0;left:0;background:#fff;}li{cursor:pointer;color:#555;height:48px;line-height:48px;padding:0 16px;", ";border-left:4px solid transparent;&:hover{background:#f7f7f7;}&.selected{border-left-color:", ";}}"], p => p.theme.transition, p => p.theme.colors.main);

class ComboBox extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      showItems: false,
      selectedIdx: -1
    });

    _defineProperty(this, "toggleItems", () => {
      this.setState(prevState => ({
        showItems: !prevState.showItems
      }));
    });

    _defineProperty(this, "selectItem", idx => () => {
      const {
        onSelect,
        items
      } = this.props;
      this.setState(() => ({
        selectedIdx: idx
      }));
      this.toggleItems();
      onSelect(items[idx].value);
    });

    _defineProperty(this, "isSelected", idx => {
      const {
        selectedIdx
      } = this.state;
      return selectedIdx === idx;
    });

    _defineProperty(this, "renderSelectedItem", () => {
      const {
        items,
        label,
        err
      } = this.props;
      const {
        selectedIdx,
        showItems
      } = this.state;
      const selectedItem = items[selectedIdx];
      return /*#__PURE__*/_react.default.createElement("div", {
        onClick: this.toggleItems
      }, label && /*#__PURE__*/_react.default.createElement(_LabelText.default, null, label), /*#__PURE__*/_react.default.createElement(SelectedItem, {
        active: showItems,
        err: err
      }, /*#__PURE__*/_react.default.createElement(SelectedItemText, null, selectedItem ? selectedItem.text : ''), /*#__PURE__*/_react.default.createElement(_SVGIcon.default, {
        name: showItems ? 'chevronUp' : 'chevronDown',
        color: "#333"
      })), err && /*#__PURE__*/_react.default.createElement(_InputError.default, null, err));
    });

    _defineProperty(this, "renderItems", () => {
      const {
        items
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(Items, null, /*#__PURE__*/_react.default.createElement("ul", null, items.map((item, idx) => /*#__PURE__*/_react.default.createElement("li", {
        key: item.value,
        className: (0, _classcat.default)({
          selected: this.isSelected(idx)
        }),
        onClick: this.selectItem(idx)
      }, item.text))));
    });
  }

  componentDidMount() {
    const {
      select
    } = this.props;

    if (select >= 0) {
      this.setState(() => ({
        selectedIdx: select
      }));
    }
  }

  render() {
    const {
      className
    } = this.props;
    const {
      showItems
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className
    }, this.renderSelectedItem(), showItems && this.renderItems(), showItems && /*#__PURE__*/_react.default.createElement(_Backdrop.default, {
      onClick: this.toggleItems
    }));
  }

}

var _default = (0, _styledComponents.default)(ComboBox).withConfig({
  displayName: "ComboBox",
  componentId: "l8utvg-3"
})(["position:relative;margin-bottom:24px;"]);

exports.default = _default;